import React from "react"
import { RightBar } from "../ui/Frame"

const RightSidebar = props => {
    return <RightBar {...props} />
}

export default RightSidebar



// WEBPACK FOOTER //
// ./src/features/editor/sidebars/RightSidebar.js